import React, { type ReactNode } from 'react';

import { RelayEnvironmentProvider } from '@atlassian/relay-environment-provider';

type AppWrapperProps = {
	children: ReactNode;
};

export function AppWrapper({ children }: AppWrapperProps): React.JSX.Element {
	return <RelayEnvironmentProvider>{children}</RelayEnvironmentProvider>;
}
